var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWalletDrop = function SvgWalletDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet-drop_svg__clip0_1458_5493)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.423 2.833A2.163 2.163 0 0012.27.841H2.16C.97.84 0 1.81 0 3V13c0 1.19.97 2.16 2.16 2.16h11.68c1.19 0 2.16-.97 2.16-2.16V4.912c0-.989-.668-1.824-1.577-2.08zM2.161 1.85H12.27c.55 0 1.01.387 1.124.902H2.16c-.423 0-.818.123-1.152.334v-.084c0-.635.517-1.152 1.152-1.152zm11.678 12.3H2.161a1.153 1.153 0 01-1.152-1.152V4.913c0-.635.517-1.151 1.152-1.151h11.678c.635 0 1.152.516 1.152 1.151v1.761h-3.218A2.315 2.315 0 009.46 8.987a2.315 2.315 0 002.313 2.313h3.218v1.698c0 .635-.517 1.152-1.152 1.152zm1.152-3.86h-3.218a1.305 1.305 0 01-1.304-1.303c0-.719.585-1.303 1.304-1.303h3.218v2.607z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.96 9.55a.525.525 0 100-1.05.525.525 0 000 1.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet-drop_svg__clip0_1458_5493"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgWalletDrop;